import "./ProductCardProfile.scss";
import {diffDays} from "../../../../shared/functions/diffDays";
import PopupBasketDesc from "../../ChildPages/Basket/components/PopupBasketDesc/PopupBasketDesc";
import {useState} from "react";
import ProductImage from "../../../../shared/ProductImage/ProductImage";

const ProductCardProfile = ({ data, onRemove, onRefresh }: { data: any, onRemove: any, onRefresh?: any }) => {
    const [ activePopup, setActivePopup] = useState(false)
    // true, поки наш запит на повернення ще виконується
    const [ refunding, setRefunding ] = useState(false)
    // повернення в обробці: або ми щойно його запустили, або сервер каже, що воно в черзі (наприклад, після оновлення сторінки)
    const isRefunding = refunding || data.refundStatus === 'pending'

    return (
        <>
            <button
                type="button"
                className={`bk-card ${isRefunding ? "is-refunding" : ""}`}
                onClick={() => setActivePopup(true)}
                title={data.product.productName}
            >
                <div className="bk-card-media">
                    <ProductImage className="bk-card-img" src={data.product.imageUrl} alt="" />
                    { isRefunding &&
                        <span className="product-refund-badge" title="Повернення в обробці" aria-label="Повернення в обробці" role="status">
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <circle cx="12" cy="12" r="9" />
                                <path d="M12 12l3.5 2" />
                                <path className="refund-clock-hand" d="M12 12V6.5" />
                            </svg>
                        </span>
                    }
                    { data.reward === "lootbox" &&
                        <span className="product-lootbox-badge" title="Предмет з ящика: повертається за 50% ціни" aria-label="Уцінка: повернення за 50% ціни">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true">
                                <path d="M19 5L5 19" />
                                <circle cx="7" cy="7" r="2.6" />
                                <circle cx="17" cy="17" r="2.6" />
                            </svg>
                        </span>
                    }
                    { data.reward === "giveaway" &&
                        <span className="product-giveaway-badge" title="Приз з розіграшу: не повертається" aria-label="Приз з розіграшу: не повертається">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <rect x="3" y="8" width="18" height="4" rx="1" />
                                <path d="M12 8v13M5 12v8a1 1 0 001 1h12a1 1 0 001-1v-8" />
                                <path d="M7.5 8a2.5 2.5 0 010-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 010 5" />
                            </svg>
                        </span>
                    }
                    { data.dateEnd && <span className="bk-card-days">{ diffDays(data.dateEnd) } дн.</span> }
                </div>
                <div className="bk-card-info">
                    <span className="bk-card-name">{data.product.productName}{data.product.variantName ? ` · ${data.product.variantName}` : ""}</span>
                    <span className="bk-card-server">{data.server?.name}</span>
                </div>
            </button>
            <PopupBasketDesc
                activePopup={activePopup}
                setActivePopup={setActivePopup}
                data={data}
                onRemove={onRemove}
                onRefresh={onRefresh}
                onRefundStateChange={setRefunding}
            />
        </>
    );
};

export default ProductCardProfile;